import { type ReactNode } from "react";
import { useSearchParams } from "react-router";
import { WayflyerError } from "shared-ui";

import { ConnectionAuthCallbackHandler } from "../../components";

import {
  AmazonPage,
  BigcommercePage,
  CodatPage,
  GoogleAdsPage,
  GoogleAnalyticsPage,
  MagentoPage,
  MockifyPage,
  MetaAdsPage,
  NetsuitePage,
  QuickbooksPage,
  ShopifyAppStorePage,
  ShopifyPage,
  StripePage,
  TikTokPage,
  WooCommercePage,
  XeroPage,
} from "./connector-pages";

const PlatformComponents: Record<string, ReactNode> = {
  shopify2: <ShopifyPage />,
  "shopify-appstore": <ShopifyAppStorePage />,
  amazonrutter: <AmazonPage />,
  stripe2: <StripePage />,
  woocommerce2: <WooCommercePage />,
  bigcommercerutter: <BigcommercePage />,
  magento2: <MagentoPage />,
  mockify: <MockifyPage />,
  ga: <GoogleAnalyticsPage />,
  google_ads2: <GoogleAdsPage />,
  facebook2: <MetaAdsPage />,
  tiktok: <TikTokPage />,
  codat_accounting: <CodatPage />,
  xero: <XeroPage />,
  netsuite: <NetsuitePage />,
  quickbooks: <QuickbooksPage />,
};

const getPlatformFromSearchParam = (searchParams: URLSearchParams): string | null => {
  if (searchParams.has("platform")) {
    return searchParams.get("platform");
  } else if (searchParams.has("complete-connection")) {
    return searchParams.get("complete-connection");
  }
  return searchParams.get("connectionSucceed");
};

export const ConnectionManager = () => {
  return (
    <ConnectionAuthCallbackHandler>
      <ConnectedPlatform />
    </ConnectionAuthCallbackHandler>
  );
};

export const ConnectedPlatform = () => {
  const [searchParams] = useSearchParams();
  const platform = getPlatformFromSearchParam(searchParams);

  if (!platform || !(platform in PlatformComponents)) {
    throw new WayflyerError("Missing or unknown platform in query params", "404");
  }

  return PlatformComponents[platform];
};
